import { Avatar, Col, Grid, Row } from 'antd';
import React, { useEffect, useState } from 'react'
import { HiOutlineBellAlert } from 'react-icons/hi2';
import { Link, useNavigate } from 'react-router-dom';
import DropDown from '../DropDown';
import { UserOutlined } from '@ant-design/icons';
import { IoIosArrowForward } from 'react-icons/io';
import { AppAction } from '../../store/actions';
import { FaBars } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { getUserData } from '../../config/getApis';

const allOptions = [
    { label: 'My Availability', value: '1' },
    { label: 'Edit Profile', value: '2' },
    { label: 'Change Password', value: '3' },
];

const DashboardActionBar = ({ text }) => {

    const dispatch = useDispatch()
    const scrn = Grid.useBreakpoint();
    const navigate = useNavigate();

    // const { data: currentUserData } = useQuery('currentUsers', getUserData);
    const userData = useSelector((state) => state?.AppReducer);
    console.log("user Updated data: ", userData)
    let user;
    if (userData?.userProfileData && Object.keys(userData?.userProfileData)?.length > 0) {
        user = userData?.userProfileData
    } else {
        user = userData?.user
    }

    const isClient = user?.userRole?.[0] === 'client';

    const options = isClient
        ? allOptions.filter((o) => o.label === 'Change Password')
        : allOptions;

    const dropDownSelector = (e) => {
        if (e.key === 'tmp-0') {
            navigate('/MyAvailability');
            return;
        } else if (e.key === 'tmp-1') {
            navigate('/EditProfile');
            return;
        } else if (e.key === 'tmp-2') {
            console.log(e.key);
            navigate('/ChangePassword');
            return;
        }
    };

    return (
        <Row className="w-full flex items-center flex-wrap mb-8">
            <Col lg={6} md={6} sm={12} xs={24} className="my-2">
                <h1 className="text-xl font-semibold">{text ? text : "Dashboard"}</h1>
            </Col>
            <Col
                lg={18}
                md={18}
                sm={12}
                xs={24}
                className="flex justify-end items-center flex-wrap sm:flex-nowrap py-3 gap-4"
            >
                {!isClient && (
                <div className="py-3 px-3 rounded-md bg-white shadow-[rgba(0,0,0,0.16)_0px_10px_36px_0px] ring-1 ring-[rgba(0,0,0,0.06)]">
                    <Link to={'/Notifications'}>
                        <HiOutlineBellAlert size={20} />
                    </Link>
                </div>
                )}

                <div className="py-2 px-4 rounded-md bg-white shadow-[rgba(0,0,0,0.16)_0px_10px_36px_0px] ring-1 ring-[rgba(0,0,0,0.06)]">
                    <DropDown
                        placement={'bottom'}
                        items={options}
                        onClick={(e) => dropDownSelector(e)}
                        children={
                            <div className="flex items-center gap-2 justify-between">
                                <div>
                                    {
                                        user?.profileImg?.length > 0 && user?.profileImg[0]?.url ?
                                            <Avatar src={user?.profileImg[0]?.url} />
                                            :
                                            <Avatar icon={<UserOutlined />} />
                                    }
                                </div>
                                <div className="flex">
                                    <span>
                                        {user?.firstName ? user?.firstName?.slice(0, 10) +
                                            ' ' +
                                            user?.lastName?.slice(0, 10)
                                            :
                                            '-'
                                        }
                                        <IoIosArrowForward className="inline" />
                                    </span>
                                </div>
                            </div>
                        }
                    />
                </div>
                {/* {scrn.lg ? null : (
                    <div className="py-3 px-3 rounded-md aspect-square bg-white shadow-[rgba(0,0,0,0.16)_0px_10px_36px_0px] ring-1 ring-[rgba(0,0,0,0.06)]">
                        <button
                            onClick={() => {
                                dispatch(AppAction.ToggleSidebar());
                            }}
                        >
                            <FaBars />
                        </button>
                    </div>
                )} */}
            </Col>
        </Row>
    )
}

export default DashboardActionBar